/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IWaitingProps } from './Waiting.props';

/**
 * Waiting - this component is a visual indication of a pre-loader.
 */
export default class Waiting extends React.PureComponent<IWaitingProps> {
    public static defaultProps: Partial<IWaitingProps> = {
        className: 'msc-waiting-circular'
    };

    public render(): JSX.Element {
        const { className, ...props } = this.props;
        const watingClassName = `msc-waiting ${className}`;

        return <div className={watingClassName} {...props} />;
    }
}
